var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 8 8",
    width: 8,
    height: 8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-167603564281324445",
    d: "M3.9999999999999996 0 C6.2076600979759995 0 7.999999999999999 1.7923399020239998 7.999999999999999 3.9999999999999996 C7.999999999999999 6.2076600979759995 6.2076600979759995 7.999999999999999 3.9999999999999996 7.999999999999999 C1.7923399020239998 7.999999999999999 0 6.2076600979759995 0 3.9999999999999996 C0 1.7923399020239998 1.7923399020239998 0 3.9999999999999996 0 Z",
    vectorEffect: "non-scaling-stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(95, 84, 87)",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(35, 31, 32)"
    },
    d: "M3.9999999999999996 0 C6.2076600979759995 0 7.999999999999999 1.7923399020239998 7.999999999999999 3.9999999999999996 C7.999999999999999 6.2076600979759995 6.2076600979759995 7.999999999999999 3.9999999999999996 7.999999999999999 C1.7923399020239998 7.999999999999999 0 6.2076600979759995 0 3.9999999999999996 C0 1.7923399020239998 1.7923399020239998 0 3.9999999999999996 0 Z",
    vectorEffect: "non-scaling-stroke"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.f1e2bd33a131f094b57fd6ba98cb47ed.svg";
export { ForwardRef as ReactComponent };